var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Login } from './pages/Login';
import { Layout } from './pages/Layout';
import '../css/App.module.scss';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { getOriginalUser } from './services/utilisateur';
export var App = function () {
    var originalUser = getOriginalUser();
    return (_jsx(_Fragment, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: !originalUser || !originalUser.UtilisateurId ? _jsx(Login, {}) : _jsx(Layout, {}) })) }));
};
//# sourceMappingURL=index.js.map